<template>

    <div class="sustainable-component admin-import-data">
        <!--<div class="bg-success mb-3 p-3 rounded">vue admin-import-data</div>-->
        <div class="container-fluid p-0 mt-3">
            <div class="row">
                <div class="col-12">
                    <v-tabs color="primary" v-model="tab">
                        <v-tab value="employees">Anställda</v-tab>
                        <v-tab value="tasks">Arbetsuppgifter</v-tab>
                        <v-tab value="criterias">Analyskriterier</v-tab>
                    </v-tabs>

                    <v-tabs-window v-model="tab">
                        <v-tabs-window-item value="employees">
                            <v-sheet class="pa-5">
                                <div class="row mt-3" v-if="resultMessage != ''">
                                    <div class="col-12">
                                        <v-alert type="success" title="Filen har importerats">
                                            <div>
                                                {{resultMessage}}
                                            </div>
                                        </v-alert>
                                    </div>
                                </div>
                                <div class="row mt-3" v-if="errorMessages.length > 0">
                                    <div class="col-12">
                                        <v-alert type="error" title="Fel vid uppladdning">
                                            <div v-for="(item, index) in errorMessages" :key="index">
                                                {{item}}
                                            </div>
                                        </v-alert>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-12">
                                        <b>Uppladdning av anställda</b>
                                    </div>
                                    <div class="col-12 mt-3">
                                        <ol class="m-0 pb-0">
                                            <li>
                                                Klicka på knappen "Bläddra" (står "Browse" i fall du har en engelsk version på din webbläsare).<br>
                                                Använder du dig av webbläsaren Chrome står det istället "Välj fil" (står "Choose File" ifall ni har engelsk version).<br><br>
                                            </li>
                                            <li>Sök dig fram till den fil som ska laddas upp och dubbelklicka på den – att skapa en importfil förklaras nedan.<br><br></li>
                                            <li>Klicka på knappen Importera.<br><br></li>
                                            <li><em>Viktigt!</em> Tilldela befattning till importerade personer, t.ex. i röret Lönesättning.<br><br></li>
                                        </ol>
                                    </div>
                                    <div class="col-12 col-md-6 mt-3">
                                        <v-form ref="employeeForm" action="/admin/ImportEmployees" method="post" enctype="multipart/form-data" @submit.prevent="handleEmployeeForm">
                                            <CommonLabelContainer title="Importera fil" class="mt-5 mb-3">
                                                <div class="container-fluid mt-3">
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <v-file-input :rules="[rules.required]" label="Ange fil" name="fileData" id="fileData"></v-file-input>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <v-btn :loading="loading"
                                                                   text="Ladda upp"
                                                                   type="submit"></v-btn>
                                                        </div>
                                                    </div>
                                                </div>
                                            </CommonLabelContainer>
                                        </v-form>
                                    </div>
                                    <div class="col-12">
                                        <b>Anvisningar - skapa en importfil ifrån Excel</b>
                                        <ol class="mt-3 mb-0 pb-0">
                                            <li>Skapa innehåll i Excel enligt bild.<br><img src="/images/ImporteraAnstallda_steg1.PNG" alt="Skapa fil"><br><br></li>
                                            <li>Välj "Spara som" ("Save as" ifall du har en engelsk version).<br><br></li>
                                            <li>Från dialogrutan väljer du csv-format enligt bilden nedan.<br><img src="/images/ImporteraAnstallda_steg2.PNG" alt="CSV-format"><br><br></li>
                                            <li>I fall det dyker upp en varning efter det att du klickat Spara, väljer du OK/fortsätt (Den varnar bara för att filen inte har full Excelfunktionalitet).<br><br></li>
                                        </ol>
                                        <div class="mb-5">
                                            <b>Beskrivning av fälten</b><br />
                                            För att kontrollera att filen ser korrekt ut kan man öppna den med "Anteckningar" och då ska filen se ut t.ex. så här:<br /><br />
                                            1;Maggan;Pettersson;19710311-6524;2011-04-14;2010-04-14<br />
                                            2;Elsa;Lööf;19720101-6542;2009-04-14;2009-04-14<br />
                                            3;Ulf;Karlsson;19710301-6432;2008-04-14;2008-04-14<br />
                                            4;Björn;Pettersson;19820101-7334;2012-04-14;2012-04-14<br />
                                            21;Per;Allardh;19690101-6532;2007-01-14;2007-04-14<br /><br /><br />
                                        </div>
                                    </div>
                                </div>

                            </v-sheet>
                        </v-tabs-window-item>
                        <v-tabs-window-item value="tasks">
                            <v-sheet class="pa-5">
                                <div class="row mt-3" v-if="resultMessage != ''">
                                    <div class="col-12">
                                        <v-alert type="success" title="Filen har importerats">
                                            <div>
                                                {{resultMessage}}
                                            </div>
                                        </v-alert>
                                    </div>
                                </div>
                                <div class="row mt-3" v-if="errorMessages.length > 0">
                                    <div class="col-12">
                                        <v-alert type="error" title="Fel vid uppladdning">
                                            <div v-for="(item, index) in errorMessages" :key="index">
                                                {{item}}
                                            </div>
                                        </v-alert>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-12">
                                        <b>Uppladdning av arbetsuppgifter</b>
                                    </div>
                                    <div class="col-12 mt-3">
                                        <ol class="m-0 pb-0">
                                            <li>Välj befattning.<br><br></li>
                                            <li>
                                                Klicka på knappen "Bläddra" (står "Browse" i fall du har en engelsk version på din webbläsare).<br>
                                                Använder du dig av webbläsaren Chrome står det istället "Välj fil" (står "Choose File" ifall ni har engelsk version).<br><br>
                                            </li>
                                            <li>Sök dig fram till den fil som ska laddas upp och dubbelklicka på den – att skapa en importfil förklaras nedan.<br><br></li>
                                            <li>Klicka på knappen Importera.<br><br></li>
                                        </ol>

                                    </div>
                                    <div class="col-12 col-md-6 mt-3">
                                        <v-form ref="worktaskForm" action="/admin/ImportWorkTasks" method="post" enctype="multipart/form-data" @submit.prevent="handleWorkTaskForm">
                                            <CommonLabelContainer title="Importera fil" class="mt-5 mb-3">
                                                <div class="container-fluid mt-3">
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <v-select name="selectedPosition" :rules="[rules.required]" bg-color="white" variant="outlined" label="Välj befattning" :items="jobPositions" v-model="selectedPosition" item-title="Name" item-value="JobPositionId"></v-select>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <v-file-input :rules="[rules.required]" label="Ange fil" name="fileData" id="fileData"></v-file-input>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <v-btn :loading="loading"
                                                                   text="Ladda upp"
                                                                   type="submit"></v-btn>
                                                        </div>
                                                    </div>
                                                </div>
                                            </CommonLabelContainer>
                                        </v-form>
                                    </div>
                                    <div class="col-12">
                                        <b>Anvisningar - skapa en importfil ifrån Excel</b>
                                        <ol class="mt-3 mb-0 pb-0">
                                            <li>Skapa innehåll i Excel enligt bild.<br><img src="/images/ImporteraArbUppg_steg1.PNG" alt="Skapa fil"><br><br></li>
                                            <li>Välj "Spara som" ("Save as" ifall du har en engelsk version).<br><br></li>
                                            <li>Från dialogrutan väljer du csv-format enligt bilden nedan.<br><img src="/images/ImporteraAnstallda_steg2.PNG" alt="CSV-format"><br><br></li>
                                            <li>I fall det dyker upp en varning efter det att du klickat Spara, väljer du OK/fortsätt (Den varnar bara för att filen inte har full Excelfunktionalitet).<br><br></li>
                                        </ol>
                                        <div class="mb-5">
                                            <b>Beskrivning av fälten</b><br />
                                            <ol type="A">
                                                <li>Arbetsuppgift</li>
                                                <li>Utbildning och krav</li>
                                            </ol>
                                            För att kontrollera att filen ser korrekt ut kan man öppna den med "Anteckningar" och då ska filen se ut t.ex. så här:<br /><br />
                                            Delta i morgonmöte;<br />
                                            Kvalitetsuppföljning;<br />
                                            Gå igenom närvarostämplingar i tidredovisningssystemet så tidigt som möjligt varje vecka och vid behov rätta och godkänna dessa;Utbildning i tidredovisningssystemet<br />
                                            Truckkörning;Truckkörkort<br /><br /><br />
                                        </div>
                                    </div>
                                </div>


                            </v-sheet>
                        </v-tabs-window-item>
                        <v-tabs-window-item value="criterias">
                            <v-sheet class="pa-5">
                                <div class="row mt-3" v-if="resultMessage != ''">
                                    <div class="col-12">
                                        <v-alert type="success" title="Filen har importerats">
                                            <div>
                                                {{resultMessage}}
                                            </div>
                                        </v-alert>
                                    </div>
                                </div>
                                <div class="row mt-3" v-if="errorMessages.length > 0">
                                    <div class="col-12">
                                        <v-alert type="error" title="Fel vid uppladdning">
                                            <div v-for="(item, index) in errorMessages" :key="index">
                                                {{item}}
                                            </div>
                                        </v-alert>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-12">
                                        <b>Uppladdning av analyskriterier></b>
                                    </div>
                                    <div class="col-12 mt-3">
                                        <ol class="m-0 pb-0">
                                            <li>Välj analyskriterie.<br><br></li>
                                            <li>
                                                Klicka på knappen "Bläddra" (står "Browse" i fall du har en engelsk version på din webbläsare).<br>
                                                Använder du dig av webbläsaren Chrome står det istället "Välj fil" (står "Choose File" ifall ni har engelsk version).<br><br>
                                            </li>
                                            <li>Sök dig fram till den fil som ska laddas upp och dubbelklicka på den – att skapa en importfil förklaras nedan.<br><br></li>
                                            <li>Klicka på knappen Importera.<br><br></li>
                                        </ol>

                                    </div>
                                    <div class="col-12 col-md-6 mt-3">
                                        <v-form ref="analysisCriteriaForm" action="/admin/ImportAnalysisCriterias" method="post" enctype="multipart/form-data" @submit.prevent="handleAnalysisCriteriaForm">
                                            <CommonLabelContainer title="Importera fil" class="mt-5 mb-3">
                                                <div class="container-fluid mt-3">

                                                    <div class="row">
                                                        <div class="col-12">
                                                            <v-select :rules="[rules.required]" name="analysisCriteria" bg-color="white" variant="outlined" label="Välj analyskriterie" :items="criterias" v-model="selectedCriteria" item-title="name" item-value="val"></v-select>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <v-file-input :rules="[rules.required]" label="Ange fil" name="fileData" id="fileData"></v-file-input>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <v-btn :loading="loading"
                                                                   text="Ladda upp"
                                                                   type="submit"></v-btn>
                                                        </div>
                                                    </div>
                                                </div>
                                            </CommonLabelContainer>
                                        </v-form>
                                    </div>
                                    <div class="col-12 mb-5">
                                        <b>Anvisningar - skapa en importfil ifrån Excel</b>
                                        <ol class="mt-3 mb-0 pb-0 mb-5">
                                            <li>Starta Anteckningar (notepad.exe).<br><br></li>
                                            <li>Mata in analysvärden, ett värde per rad. Du kan även kopiera raderna från ett t.ex. ett Exceldokument genom att markera text och sedan trycka tangenterna Ctrl och C samtidigt och sedan klistra in texten i anteckningar med Ctrl och V.<br><br></li>
                                            <li>Välj "Spara som" ("Save as" ifall du har en engelsk version).<br><br></li>
                                        </ol>
                                    </div>
                                </div>

                            </v-sheet>
                        </v-tabs-window-item>
                    </v-tabs-window>

                </div>
            </div>
            
            
          
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>


<script>

    import CommonLabelContainer from "../../common/common-label-container";
    import WorkOrganisationService from "../../Services/WorkOrganisationService";
    import ValidationService from "../../Services/ValidationService";
    import CommonSpinner from '../../common/common-spinner.vue'
    import { ref } from 'vue'
    const employeeForm = ref(null);
    const worktaskForm = ref(null);
    const analysisCriteriaForm = ref(null);

    export default {

        name: 'admin-import-data',
        props: {

        },
        components: {
            CommonLabelContainer,
            CommonSpinner
        },
        methods: {
            async handleEmployeeForm(event) {
                var result = await this.employeeForm.validate()
                if (result.valid != true)
                    return;
                return this.handleSubmit(event);
            },
            async handleWorkTaskForm(event) {
                var result = await this.worktaskForm.validate()
                if (result.valid != true)
                    return;
                return this.handleSubmit(event);
            },
            async handleAnalysisCriteriaForm(event) {
                var result = await this.analysisCriteriaForm.validate()
                if (result.valid != true)
                    return;
                return this.handleSubmit(event);
            },
            async handleSubmit(event) {
                const form = event.currentTarget;
                
                const url = new URL(form.action);
                const formData = new FormData(form);
                const fetchOptions = {
                    method: form.method,
                    body: formData,
                };
                const response = await fetch(url, fetchOptions);
                if (!response.ok) {
                    this.errorMessages = ["Det gick inte att ladda upp filen, var god prova igen senare"]
                }
                else {
                    const json = await response.json();
                    this.errorMessages = json.ErrorMessages;
                    if (this.errorMessages.length == 0) {
                        this.resultMessage = json.ConfirmMessage;
                    }
                }
            },
            async loadPositions() {
                this.jobPositions = await WorkOrganisationService.getJobPositions();
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },

        data() {
            return {
                tab:null,
                rules: ValidationService.rules(),
                option: 1,
                errorMessages: [],
                resultMessage: "",
                jobPositions: [],
                selectedPosition: null,
                selectedCriteria: null,
                criterias: [{ name: 'analyskriteria 1', val: 'criteria1' }, { name: 'analyskriteria 2', val: 'criteria2' }],
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {

        },
        mounted() {
            this.loadPositions();
        },
        setup() {
            return { employeeForm, worktaskForm, analysisCriteriaForm }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>